import * as React from 'react';
import { ThemeProvider, CssBaseline } from '@mui/material';
import theme from './utils/theme';
import Signup from './admin/Signup';
import Login from '../components/admin/Login';
import NavBar from '../components/pages/nav/NavBar';
import Footer from '../components/pages/footer/Footer';
import ForgotPassword from '../components/admin/ForgotPassword';
import AdminDashboard from '../components/admin/AdminDashboard';
import Home from '../components/pages/home/Home';
import NotFound from '../components/pages/notFound/NotFound';
import ScrollToTop from './utils/ScrollToTop';
import { AuthProvider } from '../contexts/AuthContext';
import { useLocation, Routes, Route, Outlet, Navigate } from 'react-router-dom';
import './App.scss';
import PrivateRoute from './utils/PrivateRoute';
import UpdateProfile from './admin/UpdateProfile';
import { DBProvider } from '../contexts/DBContext';
import Modal from './utils/Modal';
import LanguageWrapper from '../LanguageWrapper';

export default function App() {
  const location = useLocation();

  return (
    <ThemeProvider theme={theme}>
      <CssBaseline />

      <AuthProvider>
        <DBProvider>
          <Routes>
            <Route path='/' element={<Navigate to='/pl' replace />} />

            <Route
              path='/:lang/*'
              element={
                <LanguageWrapper>
                  <ScrollToTop state={location.state} />
                  <NavBar />
                  <Outlet />
                  <Footer />
                </LanguageWrapper>
              }
            >
              <Route index element={<Home />} />

              <Route
                path=':id'
                element={
                  <>
                    <Home />
                    <Modal />
                  </>
                }
              />

              <Route
                path=':id/:slug'
                element={
                  <>
                    <Home />
                    <Modal />
                  </>
                }
              />
            </Route>

            {/* Admin */}
            <Route path='admin/login' element={<Login />} />
            <Route path='admin/register' element={<Signup />} />
            <Route path='admin/forgot-password' element={<ForgotPassword />} />
            <Route path='admin' element={<PrivateRoute />}>
              <Route index element={<AdminDashboard />} />
              <Route path='update-profile' element={<UpdateProfile />} />
            </Route>

            <Route path='*' element={<NotFound />} />
          </Routes>

          <Outlet />
        </DBProvider>
      </AuthProvider>
    </ThemeProvider>
  );
}
